import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Card } from '../../components/Card';
import type { GetRosaScoresResponse } from '../../hooks/useGetRosaScores';

interface ScoresProps {
	scores?: GetRosaScoresResponse;
}

export function Scores({ scores }: Readonly<ScoresProps>) {
	const sections = [
		{
			score: scores?.score_a,
			title: `${I18n.get('Section')} A`,
			description: 'Chair'
		},
		{
			score: scores?.score_b,
			title: `${I18n.get('Section')} B`,
			description: 'Monitor and Phone'
		},
		{
			score: scores?.score_c,
			title: `${I18n.get('Section')} C`,
			description: 'Mouse and Keyboard'
		},
		{
			score: scores?.final_score,
			title: `${I18n.get('Final score')}`
		}
	];

	return (
		<Row justify="space-between" gutter={[30, 0]}>
			{sections.map((section) => {
				return (
					<Col key={section.title} span={6}>
						<Card
							title={section.title}
							score={section.score ?? 0}
							description={section.description}
							isFinalScore={!section.description}
						/>
					</Col>
				);
			})}
		</Row>
	);
}
